
export const DndTypes = {
    ISSUE: 'issue',
    PROJECT: 'project',
    SPRINT: 'sprint',
    USER: 'user',
    VISUAL_SPEC_ISSUE: 'visual_spec_issue',
    VISUAL_SPEC_ANNOTATION: 'visual_spec_annotation',
    VISUAL_SPEC_DOCUMENT: 'visual_spec_document'
};




// WEBPACK FOOTER //
// ./src/actions/Dnd.js